module.exports = __webpack_public_path__ + "media/images/Initials_Icon-c8212da1.svg";